import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight, Languages } from "lucide-react";
import { useLang } from "@/lib/i18n";
import NotificationBell from "@/components/NotificationBell";
import Logo from "@/components/Logo";

export default function TopBar({ title, back = true, right = null }) {
  const navigate = useNavigate();
  const { t, lang, setLang, dir } = useLang();
  const Chev = dir === "rtl" ? ChevronRight : ChevronLeft;

  return (
    <header
      data-testid="top-bar"
      className="sticky top-0 z-40 flex items-center justify-between gap-3 px-4 py-3 bg-white/85 backdrop-blur-xl border-b border-zinc-100"
    >
      <div className="flex items-center gap-2 min-w-0">
        {back && (
          <button
            data-testid="back-btn"
            onClick={() => navigate(-1)}
            className="-ms-1 h-9 w-9 rounded-full grid place-items-center hover:bg-zinc-100 active:scale-95 transition"
            aria-label={t("backLabel")}
          >
            <Chev className="h-5 w-5 text-zinc-700" aria-hidden="true" />
          </button>
        )}
        {!back && <Logo variant="mark" className="h-8 w-8" asLink={false} testId="topbar-logo" />}
        <h2 className="text-base font-semibold text-zinc-900 truncate font-display">{title}</h2>
      </div>
      <div className="flex items-center gap-2">
        {right}
        <NotificationBell />
        <button
          data-testid="lang-toggle"
          onClick={() => setLang(lang === "en" ? "ar" : "en")}
          aria-label={t("changeLanguage")}
          className="inline-flex items-center gap-1.5 h-9 px-3 rounded-full bg-zinc-100 hover:bg-zinc-200 text-xs font-semibold text-zinc-800 transition"
        >
          <Languages className="h-3.5 w-3.5" aria-hidden="true" />
          {lang === "en" ? "ع" : "EN"}
        </button>
      </div>
    </header>
  );
}
